export default "__VITE_ASSET__DbXUfg5C__"